import React, { useEffect, useState, useCallback } from "react";
import UpcomingHourlyBookingTable from "../UpcomingHourlyComponent/UpcomingHourlyBookingTable/UpcomingHourlyBookingTable";
import { getHourlyBookingsAPI } from "../../../utils/APIs/hourlyAndEditingBookingsApis";
import Loader from "../../../Loader/Loader";

const LIMIT = 10;

const PreviousHourlyPage = () => {
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchBookings = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getHourlyBookingsAPI(page, LIMIT, "previous");
      const { data, meta } = res.data;
      setData(data);
      setTotal(meta.total);
    } catch (err) {
      console.error("Failed to fetch previous hourly bookings:", err);
    } finally {
      setLoading(false);
    }
  }, [page]);

  useEffect(() => {
    fetchBookings();
  }, [fetchBookings]);

  const totalPages = Math.ceil(total / LIMIT);

  if (loading && data.length === 0) return <Loader />;

  return (
    <>
      <UpcomingHourlyBookingTable
        data={data}
        page={page}
        limit={LIMIT}
        refetchData={fetchBookings}
      />

      {total > LIMIT && (
        <div className="pagination">
          <button
            className="pagination-btn"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Prev
          </button>

          <span className="pagination-info">
            Page {page} of {totalPages}
          </span>

          <button
            className="pagination-btn"
            disabled={page === totalPages}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>
      )}
    </>
  );
};

export default PreviousHourlyPage;
